import React from 'react';
import { useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  // Don't render footer on login page
  if (location.pathname === '/login' || location.pathname === '/login/') {
    return null;
  }

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-text">
            © {currentYear} TruMerit. All rights reserved.
          </p>
        </div>
        <div className="footer-center">
          <p className="footer-subtitle">
            MeritIQ
          </p>
        </div>
        <div className="footer-right">
          <p className="footer-love">
            Global careers. Care anywhere.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
